import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useCommonStore } from '@stores/common'

import { useSlotsTrackerApi } from '@api/demo-slots/slots-tracker.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const commonStore = useCommonStore()

  void useSlotsTrackerApi({
    route: to,
    onStart: () => {
      commonStore.setLoading(true)
    },
    onFinish: () => {
      commonStore.setLoading(false)
    },
  })
})
